export default __webpack_public_path__ + "static/media/how_it_works.a82f02af.png";